import { dataFetch } from '@lib/ggj-utils'

export default {
  problemCategory(params) {
    return dataFetch('/ticket-app-web/customer/problemCategory', params, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },
  problemList(params) {
    return dataFetch('/ticket-app-web/customer/problemList', params, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },
  problemDetail(params) {
    return dataFetch('/ticket-app-web/customer/problemDetail', params, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },
}